import type { SeedingItem } from '@/app/(activity)/campaigns/[slug]/types';

export interface SeedingColumnItem {
  item: SeedingItem;
  /** 在原始列表中的下标，保证埋点/点击顺序与从左到右阅读一致 */
  index: number;
}

/**
 * 按「从左到右、再换行」把列表分到多列（round-robin）：
 *
 *   列0   列1   列2   列3
 *   [0]   [1]   [2]   [3]
 *   [4]   [5]   [6]   [7]
 *   [8]   ...
 */
export function splitItemsIntoColumns(
  items: SeedingItem[],
  columnCount: number,
): SeedingColumnItem[][] {
  if (columnCount <= 0 || items.length === 0) {
    return [];
  }

  const effectiveColumnCount = Math.min(columnCount, items.length);
  const columns = Array.from({ length: effectiveColumnCount }, () => [] as SeedingColumnItem[]);

  items.forEach((item, index) => {
    columns[index % effectiveColumnCount].push({ item, index });
  });

  return columns;
}
